export class MediCateCode {
    static Herb = 1;
    static ConcMedi = 2;
    static MediPowder = 3;
    static Pill = 4;
    

    


    value: number;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}

export class cookingMethod {

    

    cookID: string;
    displayName: string;
    constructor(value, displayName) {
        this.cookID = value;
        this.displayName = displayName;
    }
}